export default ({ bottomButton }) => [
  { title: 'Кнопки', data: bottomButton, parentName: 'bottomButton' },
  { title: 'Иконки', data: bottomButton.icon, parentName: 'bottomButton.icon' },
];
